import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-not-found',
    standalone: true,
    imports: [RouterModule, TranslocoModule, MatButtonModule, MatIconModule],
    template: `
        <div class="flex flex-col items-center justify-center min-h-screen gap-6 p-8">
            <mat-icon class="text-8xl text-secondary" svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            <h1 class="text-4xl font-bold">404</h1>
            <p class="text-xl text-secondary">{{ 'errors.page-not-found' | transloco }}</p>
            <a mat-flat-button color="primary" routerLink="/home">
                {{ 'errors.back-home' | transloco }}
            </a>
        </div>
    `,
})
export class NotFoundComponent { }
